import { ICreditCardFundSourceDetails } from './credit-card-fund-source-details';
import { FundSourceTypeEnum } from './fund-source-type-enum';
import { IOpenBankDetails } from './open-bank-details';

/**
 * Summary of how ping is being used for the purchase.
 */
export interface IPingTransactionDetails {
    /**
     * The details of the credit card that should be used to purchase the item.
     * Optional. If this is not supplied then the the buyer's existing card is used
     */
    readonly creditCardDetails?: ICreditCardFundSourceDetails;
    /**
     * Used in purchases to specify the amount that should taken from the fundsource for the purchase. Only valid for split payments
     */
    readonly fundSourceAmount?: number;
    /**
     * The fund source ID of the saved credit/debit card or bank account that the member wants to use for a payment.
     */
    readonly fundSourceId?: number;
    /**
     * Used in purchases to determine the type of fundsource used in a purchase. Can be combined with balance to perform a mixed purchases.
     */
    readonly fundSourceType?: FundSourceTypeEnum;
    /**
     * /// The details of open bank details that should be used to purchase the item. Optional.
     */
    readonly openBankDetails?: IOpenBankDetails;
    /**
     * Used to indicate the top up amount. Only valid for negative balance top ups.
     */
    readonly topupAmount?: number;
    /**
     * Used in purchases to determine if the member's Ping balance should be used for a payment.
     */
    readonly useBalance?: boolean;
}
